import type { FC } from 'react';
import React, { useContext } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Flex from '@atlaskit/primitives/components/flex';
import { xcss } from '@atlaskit/primitives/xcss';

import { ContentIcon as ContentIconCombined } from '@confluence/icons/entry-points/ContentIcon.ts';

import { PageCardContext } from '../PageCardContext.ts';

const iconBorderStyles = xcss({
	borderColor: 'color.border',
	borderStyle: 'solid',
	borderRadius: 'radius.small',
	borderWidth: 'border.width',
	height: '32px',
	width: '32px',
});

export const ContentIcon: FC = () => {
	const {
		type,
		title: { emoji },
		appearance,
		subType,
	} = useContext(PageCardContext);
	const isCompactEndOfPage = appearance === 'compact-end-of-page';

	return (
		<Flex
			alignItems="center"
			justifyContent="center"
			xcss={[!isCompactEndOfPage && iconBorderStyles]}
		>
			<ContentIconCombined type={type} emoji={emoji} subType={subType} />
		</Flex>
	);
};
